import { MODULES } from "./../../../Helpers/Constants";
import { getAccessByModuleName } from "./../../../Routes/Routes";
import React, { useContext, useEffect, useState } from "react";
import { convertDateTime } from "Helpers/date";
import { CSVLink } from "react-csv";
// Components
import Header from "../../../Components/Header/Header";
import ReactTable from "./../../../Components/Table/Table";
// Services
import { getKeywordList, getKeywordExportList } from "../../../api/mostKeywordSearch";
//scss
import styles from "./index.module.scss";
// Context
import { AppContext } from "./../../../Context/AppContext";
// Images
import ExportIcon from "./../../../Assets/images/Export.svg";
const MostKeywordSearch = (props) => {
  const { showToastMessage, setIsLoading, modules } = useContext(AppContext);
  const reference = React.useRef(null);
  const [access, setAccess] = useState({});
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [pageCount, setPageCount] = React.useState(1);
  const [defaultFilter, setDefaultFilter] = useState({
    pageIndex: 0,
    pageSize: 10,
    sortBy: [],
    filters: [],
    globalFilter: ""
  });
  // Date Range Filter Start
  let defaultType = "concat"; // date : concat
  const [searchType,setSearchType] = useState(defaultType);
  const [exportData, setExportData] = React.useState([]);
  const [exportHeader, setExportHeader] = React.useState([]);
  const [isCustomSearch,setIsCustomSearch] = useState(false);
  // Date Range Filter End

  // // Handle On Start Date Change Validation
  // // Handle On End Date Change Validation
  // // Date Validation
  //     showToastMessage(
  //       undefined,
  //       "End date should be greater than start date",
  //       "error",
  //       false
  
  //   handleGetKeywordList({
  //     ...defaultFilter,
  //   });
  //   setIsCustomSearch((isCustomSearch)?false:true);
  
  //   // Condition According To Order Type For Start Date And End Date
  //   handleGetKeywordList({
  //     ...defaultFilter,
  //   });
  //   setIsCustomSearch((isCustomSearch)?false:true);

  const handleGetKeywordList = async ({
    pageIndex,
    pageSize,
    sortBy,
    globalFilter,
    filters,
    // fromDateDefault,
    // toDateDefault,
    // searchType
  }) => {
    setDefaultFilter({ pageSize, pageIndex, filters, globalFilter, sortBy});
    let searchTypeValue = defaultType;
    setSearchType(searchTypeValue);
    setLoading(true);
    const reqBody = {
      currentPage: pageIndex,
      itemsPerPage: pageSize,
      globalSearch: globalFilter,
      filters,
      sortBy,
      searchType : searchTypeValue
    };
    setIsLoading(true);
    let userAccess = getAccessByModuleName(modules, MODULES.MOST_KEYWORD_SEARCH);
    if (userAccess && userAccess.permissions.read_access) {
      const response = await getKeywordList(reqBody);
      if (response && response.status === 200) {
        setData(response.data.data.rows);
        let count = 0;
        let countArray = response.data.data.count;
        if(searchTypeValue == 'concat'){
          count = countArray.length;
        } else {
          count = countArray[0].count;
        }
        setPageCount(Math.ceil(count / pageSize));
      } else showToastMessage(undefined, response.data.message, "error", false);
    }
    setIsLoading(false);
    setLoading(false);
  };

  const handleExportMostKeywordSearch = async ({
    sortBy,
    // fromDateDefault,
    // toDateDefault,
    // searchTypeValue
  }) => {
    let postData = {
      sortBy,
      searchType : defaultType
    };
    const response = await getKeywordExportList(postData);
    if (response && response.status === 200) {
      setExportHeader(response.data.data.header);
      setExportData(response.data.data.rows);
      reference.current?.link?.click();
    } else if (response.status === 403) {
      showToastMessage(undefined, response.data.message, "error", false);
      props.history.push("/profile");
    } else {
      showToastMessage(undefined, response.data.message, "error", false);
    }
  };

  /* Check Module Access */
  useEffect(getModuleAccess, [modules]);

  function getModuleAccess() {
    let access = getAccessByModuleName(modules, MODULES.MOST_KEYWORD_SEARCH);
    let rolesAccess = getAccessByModuleName(modules, MODULES.ROLES_RIGHTS);
    if (access) setAccess(access.permissions);
    if (access && !access.permissions.read_access) {
      showToastMessage(
        undefined,
        "You are not authorized to access.",
        "error",
        false
      );
      window.location.href = "/dashboard";
    } else {
      if (rolesAccess && !rolesAccess.permissions.read_access) {
        showToastMessage(
          undefined,
          "You are not authorized to access.",
          "error",
          false
        );
        window.location.href = "/dashboard";
      }
    }
  }
  const columns = React.useMemo(
    () => [
      {
        Header: "Keyword",
        accessor: "keyword",
        isVisible: true,
        placeholder: "Keyword",
      },
      {
        Header: "Search Count",
        accessor: "search_count",
        isVisible: true,
        placeholder: "Search Count",
        disableFilters: true
      },
      {
        Header: "Date",
        accessor: "date",
        isVisible: (searchType === 'date') ? true : false,
        placeholder: "Date",
        Cell: ({ value, row, column }) => {
          return `${
            row.original.date &&
            row.original.date !== null
              ? convertDateTime(row.original.date, 'iso', "ddd MMM DD, YYYY")
                    
              : ""
          }`;
        },
        disableFilters: true
      }
    ],
    [searchType]
  );
  return (
    <React.Fragment>
      <Header
        title="Most Keyword Search"
      />
      <div id="MainContent" className="main-content" />
      {access.read_access && (
        <React.Fragment>
          
          {
            (access.write_access &&
              <>
                <span
                  onClick={(e) => handleExportMostKeywordSearch(defaultFilter)}
                  className={`link cursor-pointer ml-3 ${styles.searchIconWrapper} float-right`}
                >
                  <img className={styles.searchIcon} src={ExportIcon} alt="" />
                </span>
                <CSVLink
                  ref={reference}
                  data={exportData}
                  headers={exportHeader}
                  filename={"MostKeywordSearch.csv"}
                  className={`link cursor-pointer ml-3 ${styles.searchIconWrapper} hidden`}
                  style={{
                    display: "none",
                    float: "right",
                    marginTop: "25px",
                  }}
                >
                </CSVLink>
              </>
            )
          }

          <ReactTable
            columns={columns}
            data={data}
            fetchData={handleGetKeywordList}
            loading={loading}
            pageCount={pageCount}
            noDataText={"There is no data to display"}
            defaultFilter={defaultFilter}
            displayGlobalSearch={false}
            isCustomSearch={isCustomSearch}
            displayLastColumnSorting={true}
          />
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
export default MostKeywordSearch;